"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.RecordFactory = void 0;
var record_1 = require("./record");
var utils_1 = require("../utils");
exports.RecordFactory = {
    createInstance: function (params) {
        var defaultProps = {
            preview: false,
            step: record_1.RECORD_STEP_DEFAULT
        };
        var _a = __assign(__assign({}, defaultProps), params), user = _a.user, cycle = _a.cycle, preview = _a.preview, dateCreated = _a.dateCreated, step = _a.step, surveyUuid = _a.surveyUuid;
        return {
            cycle: cycle,
            dateCreated: dateCreated,
            ownerUuid: user.uuid,
            ownerName: user.name,
            preview: preview,
            step: step,
            surveyUuid: surveyUuid,
            uuid: utils_1.UUIDs.v4()
        };
    }
};
//# sourceMappingURL=factory.js.map